import { Link, NavLink, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Sparkles } from "lucide-react";

const navBase =
  "px-4 py-2 rounded-full text-sm font-medium transition-colors";

export default function Layout() {
  return (
    <div className="min-h-screen bg-white text-zinc-900">
      <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-zinc-200">
        <div className="max-w-6xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="brand-link"
            className="flex items-center gap-2"
          >
            <span
              className="inline-flex items-center justify-center w-8 h-8 rounded-md text-white"
              style={{ backgroundColor: "#002FA7" }}
              aria-hidden
            >
              <Sparkles size={16} strokeWidth={2.5} />
            </span>
            <span className="font-display text-lg font-medium tracking-tight">
              ResourceDistiller
            </span>
          </Link>

          <nav className="flex items-center gap-1">
            <NavLink
              to="/"
              end
              data-testid="nav-ingest"
              className={({ isActive }) =>
                `${navBase} ${
                  isActive
                    ? "bg-zinc-900 text-white"
                    : "text-zinc-600 hover:text-zinc-900"
                }`
              }
            >
              Distilla
            </NavLink>
            <NavLink
              to="/library"
              data-testid="nav-library"
              className={({ isActive }) =>
                `${navBase} ${
                  isActive
                    ? "bg-zinc-900 text-white"
                    : "text-zinc-600 hover:text-zinc-900"
                }`
              }
            >
              Libreria
            </NavLink>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="border-t border-zinc-200 mt-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-zinc-500">
          <p>
            ResourceDistiller · Distilla l'essenza di ogni risorsa in una
            scheda leggibile.
          </p>
          <p className="font-mono text-xs">v0.1 · MVP</p>
        </div>
      </footer>

      <Toaster position="top-right" richColors />
    </div>
  );
}
